module.exports = __webpack_public_path__ + "static/media/pic10.9ff78d92.jpg";